import { isMobile } from '@/lib/device'
import i18n from '@/lib/language'
const devicePath = !isMobile ? 'pc' : 'mobile'

export default [
  {
    path: '/organization',
    name: 'OrgLayout',
    props: true,
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/components/mobile/OrgLayout`)
        : import(/* webpackChunkName: "pc-base" */ `@/components/pc/OrgLayout`),
    redirect: () => {
      return {
        name: 'OrgIndex'
      }
    },
    children: [
      {
        path: 'index',
        name: 'OrgIndex',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/Index`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/organization/Index`),
        meta: {
          title: i18n.t('message["1679"]')
        }
      },
      {
        path: 'project',
        name: 'ProjectIndexPc',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectListTab`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/organization/ProjectIndex`),
        meta: {
          title: i18n.t('message["1679"]')
        }
      },
      {
        path: 'member',
        name: 'MemberPro',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/MemberProject`)
            : import(/* webpackChunkName: "pc-base" */ `@/pc/organization/ProjectIndex`),
        meta: {
          title: i18n.t('message["1679"]')
        }
      },
      {
        path: '',
        name: 'Manage',
        component: () => isMobile
          ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/Index`)
          : import(/* webpackChunkName: "pc-base" */ `@/pc/organization/ManageList`),
        children: [
          {
            path: 'person',
            name: 'OrgPerson',
            component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/organization/PersonList`)
          },
          {
            path: 'invite',
            name: 'OrgInvite',
            component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/organization/InviteLink`)
          },
          {
            path: 'qw',
            name: 'OrgQw',
            component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/organization/Qwdingding`)
          },
          {
            path: 'cloud',
            name: 'OrgCloud',
            component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/organization/LCloud`)
          },
          {
            path: 'projects',
            name: 'OrgProjects',
            component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/organization/orgProjects`)
          }
        ]
      }
    ]
  },
  {
    path: '/organization/invitejoinfirst',
    name: 'OrgInviteFirst',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/organization/inviteJoinFirst`)
  },
  {
    path: '/organization/invitejoin',
    name: 'OrgInviteJoin',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/organization/InviteJoin`)
  },
  {
    path: '/organization/invitejoin2',
    name: 'OrgInviteJoin2',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/organization/InviteJoin2`)
  },
  {
    path: '/organization/invitejoinresult',
    name: 'OrgInviteResult',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/organization/InviteJoinResult`)
  },
  {
    path: '/organization/invitejoinlose',
    name: 'OrgInviteJoinLose',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/organization/InviteJoinLose`)
  }
]
